/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Remind_LeadInputs */

const en_how_page_remind_lead = /** @type {(inputs: How_Page_Remind_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The reminder arrives on its own.`)
};

const pl_how_page_remind_lead = /** @type {(inputs: How_Page_Remind_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przypomnienie przychodzi samo.`)
};

/**
* | output |
* | --- |
* | "The reminder arrives on its own." |
*
* @param {How_Page_Remind_LeadInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_remind_lead = /** @type {((inputs?: How_Page_Remind_LeadInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Remind_LeadInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_remind_lead(inputs)
	return en_how_page_remind_lead(inputs)
});